<div class="col-xs-12">
  <!-- fieldgroups -->
  <div ng-repeat="grp in vm.exam.template.fieldgroups">
    <!-- Group header -->
    <h5 class="dl-horizontal" ng-hide="grp.label == ''" data-ng-model="grp.label"
        style="border-bottom: 1px solid black; border-top: 1px solid black;  padding-top: 5px; padding-bottom: 5px">
      {{grp.label}}
    </h5>
    <h5 class="dl-horizontal" ng-show="grp.label == ''" data-ng-model="grp.label"
        style="border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px">
    </h5>
    <!-- fields col view -->
    <dl class="dl-horizontal" ng-if="vm.exam.template.layout === 'col' || !vm.exam.template.layout">
      <dt ng-repeat-start="field in grp.fields">{{field.label}}</dt>
      <dd ng-repeat-end>
        <examtagstring valuearray="field.avalues"></examtagstring>
      </dd>
    </dl>

    <!-- fields row view -->
    <div class="dl-horizontal" ng-if="vm.exam.template.layout === 'row'">
      <div style="font-weight: bold" ng-repeat-start="field in grp.fields">{{field.label}}</div>
      <div class="spacer-bottom" ng-repeat-end>
        <examtagstring valuearray="field.avalues"></examtagstring>
        </dd>
      </div>
    </div>
  </div>

  <!-- exam images -->
  <div class="spacer-top" ng-if="vm.exam.files.length > 0">
    <h5 class="dl-horizontal"
        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">
      Bilder der Untersuchung</h5>
    <imagelist images="vm.exam.files"></imagelist>
  </div>

  <div ng-if="vm.exam.template.biopsy">
    <h5 class="dl-horizontal"
        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">
      Biopsien
    </h5>
    <div class="row" ng-repeat="bio in vm.exam.template.biopsy.biopsies">
      <div class="col-xs-12">{{bio.label}} -
        <examtagstring valuearray="bio.avalues"></examtagstring>
        <span ng-show="bio.result">: {{bio.result}}</span></div>
    </div>
  </div>

  <!-- exam trackers -->
  <div class="spacer-top" ng-if="vm.exam.template.trackervalues">
    <h5 class="dl-horizontal"
        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">
      Meßwerte
    </h5>

    <dl class="dl-horizontal">
      <dt ng-repeat-start="tr in vm.exam.template.trackervalues">{{tr.name}}</dt>
      <dd ng-repeat-end>
        <div ng-repeat="set in tr.entries">
          <div ng-repeat="def in set">{{def.label}}: {{def.value}} {{def.unit}} (Referenzbereich: {{def.normmin}} - {{def.normmax}})</div>
        </div>
      </dd>
    </dl>
  </div>


  <!-- Befundblock  -->
  <div ng-if="vm.exam.includefindings === false || !vm.exam.includefindings">
    <h5 class="dl-horizontal"
        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">
      Befund</h5>
    <dl class="dl-horizontal">
      <dt>Zusammenfassung</dt>
      <dd>
        <examtagstring valuearray="vm.exam.template.diagnosis.avalues"></examtagstring>
      </dd>
      <dt>Empfehlung</dt>
      <dd>
        <examtagstring valuearray="vm.exam.template.recommendation.avalues"></examtagstring>
      </dd>
      <dt>Anmerkung</dt>
      <dd>
        <examtagstring valuearray="vm.exam.template.comment.avalues"></examtagstring>
      </dd>
    </dl>
  </div>

</div>